import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/onboarding/locations")({
  component: LocationsStep,
});

/** Saved places are not collected. Alerts follow live GPS on Home. */
function LocationsStep() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/onboarding/alerts", replace: true });
  }, [navigate]);
  return null;
}
